/* unplugin-vue-components disabled */import { render } from "./App.vue?vue&type=template&id=4c419728"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=4c419728&lang=less"

import exportComponent from "C:\\Users\\DZ\\Desktop\\dz-project\\cps-expert-popularize\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__